import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";
import { Modal } from "react-bootstrap";
import PublicTagShape from "./PublicTagShape";
import ProductAllergens from "./ProductAllergens";
import DragScroll from "components/common/DragScroll";
import productGridPlaceholder from "assets/images/productGridPlaceholder.png";
import { getAdjustedFontSize } from "../Common/StylesHelper";
const ProductDetailsModal = ({
  show,
  onHide,
  product,
  currencyInfo,
  styles,
  primaryColor,
  isApplyBlackColor,
  language,
  config,
  theme,
}) => {
  const isArabic = language === "ar";

  const title = isArabic
    ? product?.productTitleAr || product?.productTitle
    : product?.productTitle;

  const description = isArabic
    ? product?.productDescriptionAr || product?.productDescription
    : product?.productDescription;

  const priceAndSizes = [
    ...(product?.addonsOptions?.priceAndSizes || []),
    ...(product?.addonsOptions?.modifierOptions || []),
  ];

  if (!product) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      className="product_details_popup"
      style={{ direction: isArabic ? "rtl" : "ltr" }}
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body className="product_details_popup_body">
        <div className="product_details_popup_inner" style={{ padding: 15 }}>
          <div className="popup_image" style={{ textAlign: "center" }}>
            <img
              src={product.imageUrl || productGridPlaceholder}
              alt=""
              className="img-fluid"
            />
          </div>

          <div className="popup_content">
            <div className="g_between align-items-start">
              <div className="d-flex align-items-center justify-content-between gap-2 price_title_main_wrapper">
                <h3
                  className="popup_title "
                  style={{
                    fontFamily: styles?.productTitle?.family,
                    color: isApplyBlackColor
                      ? "#000"
                      : styles?.productTitle?.color,
                      fontSize:"16px"
                  }}
                >
                  {title}
                </h3>
                <div className="product_calorie_wrapper">
              <span
                className="product_calorie"
                style={{
                  fontFamily: styles?.productCalorie?.family,
                  color: isApplyBlackColor
                    ? "#000"
                    : styles?.productCalorie?.color,
                }}
              >
                {product.productCalorie}
              </span>
            </div>

              </div>

              {product.tags && (
                <div>
                  <PublicTagShape
                    shape={product.tags.id}
                    color={product.tags.color}
                    name={product.tags.label}
                    styles={styles}
                    width={55}
                    height={55}
                    wrapperClass="common_shape_tag"
                  />
                </div>
              )}
            </div>
            
             {product?.addonsOptions?.priceAndSizes?.length === 0 && (
              <div className="popup_price g_between">
                <PublicPreviewPriceDisplay
                  dir="ltr"
                  currencyInfo={currencyInfo}
                  productPrice={product.productPrice}
                  width={18}
                  height={18}
                  primaryColor="#000"
                  extraSpanStyles={{
                    fontSize: getAdjustedFontSize(24, styles?.productPrice?.family),
                  }}
                />

                {/* <span className="product_calorie">{product.productCalorie}</span> */}
              </div>
            )}
            {!!description && (
              <p
                className={`popup_description`}
                data-font_family = {styles?.productDescription?.family}
                style={{
                  fontFamily: styles?.productDescription?.family,
                  color: isApplyBlackColor
                    ? "#000"
                    : styles?.productDescription?.color,
                }}
              >
                {description}
              </p>
            )}
            {priceAndSizes.length > 0 && (
              <div className="price-and-sizes-container popup_price_sizes">
                <DragScroll className="inner_section">
                  {priceAndSizes.map((sizeOption) => (
                    <div key={sizeOption.id} className="size-price-item">
                      <span
                        className="size-name"
                        style={{
                          fontFamily: styles?.productTitle?.family,
                          color: isApplyBlackColor
                            ? "#000"
                            : styles?.productTitle?.color,
                        }}
                      >
                        {sizeOption.name}
                      </span>

                      <span
                        className="size-price ltr w_fit_content"
                        style={{
                          fontFamily: styles?.productTitle?.family,
                          color: isApplyBlackColor
                            ? "#000"
                            : styles?.productTitle?.color,
                        }}
                      >
                        <PublicPreviewPriceDisplay
                          currencyInfo={currencyInfo}
                          productPrice={sizeOption.price}
                          width={10}
                          height={10}
                          primaryColor="#000"
                          extraSpanStyles={{
                            fontSize: getAdjustedFontSize(12, styles?.productPrice?.family),
                          }}
                        />
                      </span>
                    </div>
                  ))}
                </DragScroll>
              </div>
            )}
            
            {product.allergens?.length > 0 && (
              <div>
                <h6 className="mb-2 mt-3"></h6>

                <ProductAllergens
                  allergens={product.allergens}
                  showAllergens={config.showAllergens}
                  allergenBackgroundColor={theme.allergenBackgroundColor}
                />
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductDetailsModal;
